import { Stack } from "@fluentui/react";
import type EditedPropertiesPanelNewProps from "./EditedPropertiesPanelNewProps";
import styles from "./editedPropertiesPanelNew.module.scss";
import IsaacList from "../../../../components/isaacList/IsaacList";
import { useMemo } from "react";
import type RenderableEditableProperty from "../../../../types/RenderableEditableProperty";

//  TODO REWORK

const EditedPropertiesPanelNew: React.FunctionComponent<EditedPropertiesPanelNewProps> = ({
    calculationResults,
    construction
}) => {
    const items = useMemo<RenderableEditableProperty[]>(() => {
        if (!construction) {
          return [];
        }

        if(calculationResults)
          return calculationResults.editedConstructionProperties.filter(p => !p.isMatlabResult).map(p => ({
            entity: p.entityName,
            property: p.propertyName,
            currentValue: String(p.newValue ?? ''),
            oldValue: String(p.oldValue ?? ''),
            compartment: p.compartment,
            position: p.position,
          }));

        return []
    }, [calculationResults,construction]);
    
    return (
    <Stack grow={1} className={styles.container}>
      {items?.length > 0 && (
        <>
          {/* TODO: Move all text into translation files */}
          <h3 className={styles.header}>Edited properties</h3>
          <IsaacList<RenderableEditableProperty>
            items={items}
              onRenderCell={item => {
                const hasCompartment = item?.compartment !== undefined && item?.compartment !== null;
                const hasPosition = item?.position !== undefined && item?.position !== null;

                let suffix = "";

                if (hasCompartment && hasPosition) {
                  suffix = `(${item.compartment},${item.position})`;
                } else if (hasCompartment) {
                  suffix = `(${item.compartment})`;
                } else if (hasPosition) {
                  suffix = `(${item.position})`;
                }

                return (
                  <>
                    {item?.entity}
                    {suffix}
                    {` - ${item?.property} :`}{" "}
                    <s>{item?.oldValue}</s> <b>{item?.currentValue}</b>
                  </>
                );
              }}
          />
        </>
      )}
    </Stack>
  );
};

export default EditedPropertiesPanelNew;